/**
 * 解析searchpath 判断为首页或是列表页
 */
const checkSearchPath = function checkSearchPath(searchPath) {
    if (!searchPath || typeof searchPath !== 'string') return [];

    const searchArr = searchPath.split(/-+/g);

    if (searchArr[searchArr.length - 1] === '') {
        searchArr.splice(searchArr.length - 1);
    }

    return searchArr;
};

export { checkSearchPath };
